import { apiFetch, attendreTache, EN_TETE_TACHE_ASYNCHRONE } from './api';

/**
 * Modèles de contrat (Paramétrage > Modèles de contrat).
 *
 * Un modèle est une trame : titre, sous-titre, référence légale, préambule
 * et articles. Il se RECOPIE dans un contrat (cf. contratService
 * .appliquerModeleContrat) : corriger un modèle ne réécrit jamais un
 * contrat déjà établi.
 */

/** Tous les modèles ; `{ actif: true }` pour n'avoir que ceux proposés au choix. */
export function getModelesContrat(params = {}) {
  const query = new URLSearchParams();
  if (params.actif !== undefined && params.actif !== '') query.set('actif', params.actif);
  const s = query.toString();
  return apiFetch(`/modeles-contrat${s ? `?${s}` : ''}`);
}

/** Vocabulaire des balises {{...}} que le serveur substitue au rendu. */
export function getBalisesContrat() {
  return apiFetch('/modeles-contrat/balises');
}

export function getModeleContrat(id) {
  return apiFetch(`/modeles-contrat/${id}`);
}

export function createModeleContrat(body) {
  return apiFetch('/modeles-contrat', { method: 'POST', body: JSON.stringify(body) });
}

export function updateModeleContrat(id, body) {
  return apiFetch(`/modeles-contrat/${id}`, { method: 'PUT', body: JSON.stringify(body) });
}

export function deleteModeleContrat(id) {
  return apiFetch(`/modeles-contrat/${id}`, { method: 'DELETE' });
}

/* ---------- PDF d'exemple (migration 052) ---------- */

const API_URL = process.env.REACT_APP_API_URL || '/api';

/** URL du PDF d'exemple : `apercu` l'affiche dans un cadre, sinon téléchargement. */
export function urlExempleModele(id, { apercu = false } = {}) {
  return `${API_URL}/modeles-contrat/${id}/exemple${apercu ? '?apercu=1' : ''}`;
}

/** Dépose (ou remplace) le PDF d'exemple d'un modèle. */
export async function deposerExempleModele(id, fichier) {
  const corps = new FormData();
  corps.append('fichier', fichier);
  const res = await fetch(`${API_URL}/modeles-contrat/${id}/exemple`, {
    method: 'POST',
    credentials: 'include',
    body: corps,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.message || `Dépôt impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}

export function retirerExempleModele(id) {
  return apiFetch(`/modeles-contrat/${id}/exemple`, { method: 'DELETE' });
}

/** Lit un contrat PDF et renvoie la trame (titre, sous-titre, référence, préambule, articles). */
export async function analyserPdfModele(fichier) {
  const corps = new FormData();
  corps.append('fichier', fichier);
  const res = await fetch(`${API_URL}/modeles-contrat/analyser`, {
    method: 'POST',
    credentials: 'include',
    headers: EN_TETE_TACHE_ASYNCHRONE,
    body: corps,
  });
  const json = await res.json().catch(() => ({}));
  // Lancé en tâche de fond : on attend son résultat (même forme).
  if (res.status === 202 && json.tacheId) return attendreTache(json.tacheId);
  if (!res.ok) {
    const err = new Error(json?.message || `Analyse impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}
